const HEX_COLOR = /^#(?:[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/;

export const withAlpha = (color: string, alpha: number): string => {
  if (!HEX_COLOR.test(color)) return color;

  const channel = Math.round(Math.min(1, Math.max(0, alpha)) * 255)
    .toString(16)
    .padStart(2, '0');

  return `${color.slice(0, 7)}${channel}`;
};
